
import { Component, Vue, Emit, Prop, Watch } from "vue-property-decorator";
import LongArrowLeftIcon from "@/assets/icons/LongArrowLeftIcon.vue";
import ArrowDownIcon from "@/assets/icons/ArrowDown.vue";
import { CommunityQmiDetails, QmiDays, SidebarHomePlan, planDetails } from "@/types/sidebar";
import { QmiDaysFilter } from "@/constant";
import RangeSlider from "./RangeSlider.vue";
import { NeighborhoodHomePlans } from "@/types";
@Component({
components: {
    LongArrowLeftIcon,
    RangeSlider,
    ArrowDownIcon
  },
})
export default class MobileFilterModal extends Vue {
  refs!: any;
  private listHomeType = [] as string[];
  private listPlanName = [] as string[];
  private qmiDaysFilter = QmiDaysFilter;
  private qmiFilterList = [] as QmiDays[];
  private allPlansSelected = false;
  private showPlanName = false;
  private disableApply = true;
  private isPriceApplied = false;
  private planNameQmiList =[] as planDetails[];
  @Prop() planPriceExsist: boolean;
  @Prop() listHomeTypeMobileFilter: string[];
  @Prop() listPlanNameMobileFilter: string[];
  @Prop() qmiFilterListMobileFilter: QmiDays[];
  @Prop() communityHomePlans: SidebarHomePlan[];
  @Prop() homeTypeList: Set<string>;
  @Prop() selectedNeighborhoodIds!: string[];
  @Prop() minPriceRangeMobileFilter!: number;
  @Prop() maxPriceRangeMobileFilter!: number;
  @Prop() showMinPriceRangeMobileFilter!: number;
  @Prop() showMaxPriceRangeMobileFilter!: number;
  @Prop() showPriceRangeMobileFilter!: boolean;
  @Prop() qmiDetails!:CommunityQmiDetails;
  @Prop() enableMobileApply!: boolean;
  @Prop() homeTypeCount: number;
  @Emit("toggleMobileFilterModalVisibility") toggleMobileFilterModalVisibility(showMobileFilters:boolean) {}
  @Emit("applyMobileFilters")applyMobileFilters(listPlanName:string[],listHomeType:string[],qmiFilterList:QmiDays[]){}
  @Emit("clearMobileFilters")clearMobileFilters(){}
  @Emit("updatePriceRangeMobile") updatePriceRangeMobile(minValue: number,maxValue: number){}
  @Emit("checkHomeTypeCount") checkHomeTypeCount() {}
  @Watch("listPlanName") updatePlansList() {
    this.allPlansSelected = this.listPlanName.length === this.planNameQmiList.length;
  }
  @Watch('changeFilters') enableApply(){
    this.disableApply = !(this.changeFilters || this.isPriceApplied);
  }
  @Watch("enableMobileApply",{immediate:true}) updateApply(){
    this.disableApply = !this.enableMobileApply;
    this.isPriceApplied = this.enableMobileApply;
    this.enableApply();
  }
  get changeFilters(){
      const isFiltersUpdated = (!!this.listHomeType.length || !!this.listPlanName.length || !!this.qmiFilterList.length );
      return isFiltersUpdated;
  }
  mounted(){
    this.listHomeType=this.listHomeTypeMobileFilter;
    this.listPlanName=this.listPlanNameMobileFilter;
    this.qmiFilterList=this.qmiFilterListMobileFilter.slice(0);
    if(this.listPlanName.length === this.communityHomePlans.length){
      this.allPlansSelected = true;
    }else{
      this.allPlansSelected = false;
    }
    const planId = [] as string[];
    this.communityHomePlans.forEach((homePlan)=> {
      this.planNameQmiList.push({plan_id:homePlan.plan_id,plan_name:homePlan.plan_name});
      planId.push(homePlan.plan_id)
    });
    for(const key of Object.keys(this.qmiDetails)){
      this.qmiDetails[key].forEach((qmi)=> {
        if(!planId.includes(qmi.plan_code)){
          this.planNameQmiList.push({plan_id:qmi.plan_code,plan_name:qmi.plan_market_name})
        }
      });
    }
    window.addEventListener('click', this.hideDropDown);
  }

  hideDropDown(e: Event) {
    const planName = document.querySelector('.planName');
    if (planName && !planName.contains(e.target as Node)) {
      this.showPlanName = false;
    }
  }
  selectAllPlans() {
    this.listPlanName = [];
    if (!this.allPlansSelected) {
      this.planNameQmiList.forEach((plan) => {
        this.listPlanName.push(plan.plan_name);
      });
    }
    this.allPlansSelected = !this.allPlansSelected;
  }

  applyFilters(){
    this.applyMobileFilters(this.listPlanName,this.listHomeType,this.qmiFilterList);
    this.toggleMobileFilterModalVisibility(false);
  }
  clearFilters(){
    this.toggleMobileFilterModalVisibility(false);
    this.clearMobileFilters();
  }

  handleQmiDaysClick(event){
    const qmiDaysValue = event.srcElement.attributes[1].value;
    const qmiDay:QmiDays[]=this.qmiDaysFilter.filter((element)=>element.value===qmiDaysValue);
    const index = this.qmiFilterList.indexOf(qmiDay[0]);
    if (index >= 0) {
      this.qmiFilterList.splice(index, 1)
    } else {
      this.qmiFilterList.push(qmiDay[0])
    }
  }
}
